import React from 'react';
import styled from 'styled-components';

import SearchInputIcon from '../../../../../Icons/SearchInputIcon';
import {Row, Column, CenteredRow} from './../../../common/Layouts/Layouts';

const AnswerBlock = () => (
  <AnswerBlockWrapDiv>
    <ContentWrapperDiv>
      <Row>
        <QuestionTypeWrapperDiv></QuestionTypeWrapperDiv>
      </Row>

      <QuestionWrapperDiv>
        <QuestionTextWrapper></QuestionTextWrapper>
        <QuestionTextWrapper></QuestionTextWrapper>
      </QuestionWrapperDiv>

      <AskedByUserBlock>
        <UserAvatarWrapperDiv>
          <UserAvatarContentWrapperDiv>
            <UserAvatarNameTextWrapper></UserAvatarNameTextWrapper>
          </UserAvatarContentWrapperDiv>
        </UserAvatarWrapperDiv>

        <AskedByUserDiv>
          <UserBlockContentWrapperDiv>
            <Column>
              <UserFullNameWrapperDiv></UserFullNameWrapperDiv>
              <StayFeildWrapperDiv></StayFeildWrapperDiv>
            </Column>
            <CenteredRow>
              <ReAskButtonWrapperDiv></ReAskButtonWrapperDiv>
              <ReAskButtonWrapperDiv></ReAskButtonWrapperDiv>
            </CenteredRow>
          </UserBlockContentWrapperDiv>
        </AskedByUserDiv>
      </AskedByUserBlock>

      <AnsweredByUserBlock>
        <AnsweredByUserWrapperDiv></AnsweredByUserWrapperDiv>
      </AnsweredByUserBlock>

      <ViewMoreAnswersBlock></ViewMoreAnswersBlock>
    </ContentWrapperDiv>
  </AnswerBlockWrapDiv>
);

export default AnswerBlock;

const AnswerBlockWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding:${props.theme.spacing.large};
  padding-left: ${props.theme.spacing.large};
  padding-right: ${props.theme.spacing.large};
  padding-top: ${props.theme.spacing.xlarge};
  padding-bottom: ${props.theme.spacing.xlarge};
  width:100%;

`,
);

const ContentWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  border-radius:${props.theme.misc.borderRadius.xlarge};

  padding: ${props.theme.spacing.large};

`,
);

const QuestionTypeWrapperDiv = styled(Column)(
  props => `
  padding: ${props.theme.spacing.small};
  background-color: ${props.theme.colors.goBrandBlue.light};
  border-radius: 1.3rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  width:16.6rem;
  height:2.6rem;
`,
);

const QuestionWrapperDiv = styled(Column)(
  props => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  width: 80%;
`,
);

const QuestionTextWrapper = styled.p(
  props => `
  background-color:${props.theme.colors.goBrandBlue.medium};
  width:100%;
  height:2.6rem;
  border-radius:${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.small};

`,
);

const AskedByUserBlock = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.large};
  padding-bottom: ${props.theme.spacing.xlarge};
`,
);

const UserAvatarWrapperDiv = styled(Column)(
  props => `
  width: 5%;
  padding-right: ${props.theme.spacing.small};
`,
);

const UserAvatarContentWrapperDiv = styled(Column)(
  props => `
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background-color: ${props.theme.colors.goBrandBlue.medium};
  align-items: center;
  justify-content: center;
  position: relative;
`,
);

const UserAvatarNameTextWrapper = styled.span(
  props => `
  color: ${props.theme.colors.downriver.dark};
  font-size: ${props.theme.font.custom(16)};

`,
);

const AskedByUserDiv = styled(Column)(
  props => `
  width: 95%;
  padding-left: ${props.theme.spacing.small};
`,
);

const abc = styled(Column)(props => ``);

const UserBlockContentWrapperDiv = styled(Row)(
  props => `
  justify-content: space-between;
`,
);

const UserFullNameWrapperDiv = styled(Row)(
  props => `
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:25.6rem;
  height:2.5rem;
  margin-top:${props.theme.spacing.small};
`,
);

const StayFeildWrapperDiv = styled(Row)(
  props => `
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:15.2rem;
  height:1.2rem;
  margin-top:${props.theme.spacing.small}
`,
);

const GreyedTextWrapper = styled(Column)(
  props => `
  padding-bottom: ${props.theme.spacing.small};
  color: ${props.theme.colors.downriver.dark};
  font-size: ${props.theme.font.custom(14)};
`,
);

const ReAskButtonWrapperDiv = styled(Column)(
  props => `
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:14.6rem;
  height:4.9rem;
  margin-right: ${props.theme.spacing.base};
`,
);

const ViewMoreAnswersBlock = styled(Column)(
  props => `
  padding-top: ${props.theme.spacing.base};

  border-radius: ${props.theme.misc.borderRadius.small};
  background-color:${props.theme.colors.goBrandBlue.medium};
  width:15%;
  height:1.2rem;
`,
);

const AnsweredByUserBlock = styled(Column)(
  props => `
  padding-bottom: ${props.theme.spacing.base};
`,
);

const AnsweredByUserWrapperDiv = styled(Column)(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  background-color:${props.theme.colors.goBrandBlue.medium};
  width:100%;
  height:10.2rem;
`,
);
